import { createSlice } from '@reduxjs/toolkit'
import { v4 as uuidv4 } from 'uuid';
export const initialState = {
    dialogsData: {

    },
}

export const dialogSlice = createSlice({
    name: 'common/dialog',
    initialState,
    reducers: {
        openDialog: (state, action) => {
            state.dialogsData[uuidv4()] = action.payload
        },
        closeDialog: (state, action) => {
            state.dialogsData[action.payload].isOpen = false
        },
        onClosedDialog: (state, action) => {
            delete state.dialogsData[action.payload];
        },
    },
})

export const { openDialog, closeDialog, onClosedDialog } = dialogSlice.actions

export default dialogSlice.reducer
